import { render, staticRenderFns } from "./rf_Text.vue?vue&type=template&id=17d3bfb3&scoped=true&"
import script from "./rf_Text.vue?vue&type=script&lang=js&"
export * from "./rf_Text.vue?vue&type=script&lang=js&"
import style0 from "./rf_Text.vue?vue&type=style&index=0&id=17d3bfb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3bfb3",
  null
  
)

export default component.exports